import type { Component } from "solid-js";
import { Show } from "solid-js";
import NotFoundPage from "../pages/NotFoundPage";
import type { ProductFeature } from "../state/customer";
import FeatureService from "../services/FeatureService";

const withPageProductFeatureCheck =
  <P extends object>(WrappedComponent: Component<P>, feature: ProductFeature): Component<P> =>
  (props) => (
    <Show when={FeatureService.hasFeature(feature)} fallback={<NotFoundPage />}>
      <WrappedComponent {...props} />
    </Show>
  );

export default withPageProductFeatureCheck;
